











 















const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgTeamMembersRow_teamMember",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrgTeamMemberMenu_teamMember"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "picture",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "preferredName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLead",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrgAdmin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSelf",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PromoteTeamMemberModal_teamMember"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RemoveTeamMemberModal_teamMember"
    }
  ],
  "type": "TeamMember",
  "abstractKey": null
};

(node ).hash = "09d6ffc6fe0bcbe53805fc92e8b81e89";

export default node;
